/**
 * Generates CSS class name based on choice image size number
 * @param size - The choice image size number
 * @returns CSS class name in format 'cog-choice-image--size-{number}'
 */
function getChoiceImageSizeClassName(size: number): string {
	return `cog-choice-image--size-${size}`;
}

/**
 * Get the CSS class name for a specific choice image size
 * @param size - The choice image size (0+)
 * @returns The corresponding CSS class name
 */
export function getChoiceImageSizeClass(size: number): string {
	if (size < 0 || !Number.isInteger(size)) {
		console.warn(`Invalid choice image size: ${size}. Expected non-negative integer.`);
		return getChoiceImageSizeClassName(0);
	}

	return getChoiceImageSizeClassName(size);
}